var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ProductionListings.jinja');
require('./ProductionListings.less');

var ProductionListingsInner = require('front/components/ProductionListings/ProductionListingsInner');
var ProductionListingsInnerRuntime = require('front/components/ProductionListings/ProductionListingsInnerRuntime.jinja');

module.exports = Base.extend({

    template: template,

    events: {
        'click .ProductionListings-header-item': 'onSorted'
    },

    // VIEWS_TO_REGISTER: {
    //     'ProductionListingsInner': {selector: '.ProductionListingsInner', viewConstructor: ProductionListingsInner}
    // },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    activate: function () {
        return Base.prototype.activate.call(this)
            .then(function () {

                this.ProductionListingsInner = new ProductionListingsInner({
                    el: '.ProductionListingsInner'
                });

                this.ProductionListingsInner.activate();

                this.items = JSON.parse(this.$('.ProductionListings-body').attr('data-items'));

                _.each(this.items, function (item) {
                    item.datesParsed = this.parseDates(item.dates);
                }.bind(this));

            }.bind(this));
    },


    parseDates: function (str) {
        //find first year, can be set only for end dates
        str = str.toLowerCase();

        var tmp = str.match(/\d\d\d\d/);
        var year = tmp ? tmp[0] : 9999;

        //remove end dates
        var str = ' ' + str.split('-')[0] + ' ';

        //find day
        var tmp = str.match(/\D(\d\d?)\D/);
        var day = tmp ? tmp[1] : undefined;

        //find month signature, we are lucky, cause first letters doesn't intersects with any fullnames of seasons or modifiers or other months
        var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        var month;

        for (var i = 0; i < months.length; i++) {
            if (str.indexOf(months[i]) >= 0) {
                month = i + 1;
                break;
            }
        }

        //find season signature, we are lucky here too
        var seasons = ['spr','sum','aut','fal','win'];
        var seasonsMonth = [3, 6, 9, 9, 12];
        var seasonMonth;

        for (var i = 0; i < seasons.length; i++) {
            if (str.indexOf(seasons[i]) >= 0) {
                seasonMonth = seasonsMonth[i];
                break;
            }
        }

        //find month modifier
        var modifiers = ['mid','early','end', 'start', 'late'];
        var modifiersDay = [15, 1, 31, 1, 31];
        var modifierDay;

        for (var i = 0; i < modifiers.length; i++) {
            if (str.indexOf(modifiers[i]) >= 0) {
                modifierDay = modifiersDay[i];
                break;
            }
        }

        if (!day) {
            day = modifierDay ? modifierDay : 1;
        }

        if (!month) {
            month = seasonMonth ? seasonMonth : 1;
        }

        return year + '-' + ('00' + month).substring(Math.min(('' + month).length, 2)) + '-' + ('00' + day).substring(Math.min(('' + day).length, 2));
    },


    onSorted: function (e) {
        if (!this.items) return;

        var $item = $(e.currentTarget).closest('.ProductionListings-header-item');

        if ($item.hasClass('ProductionListings-header-item--expand')) {
            this.toggleAll();

            return;
        }

        var typeSort = $item.data('sort');
        var order = $item.attr('data-order');
        var newData = {};

        if (order == 1) {
            $item.attr('data-order', '0');
            order = 0;
        } else {
            $item.attr('data-order', '1');
            order = 1;
        }

        this.order = order;
        this.typeSort = typeSort;
        this.$('.ProductionListings-header-item--active').removeClass('ProductionListings-header-item--active');

        $item.addClass('ProductionListings-header-item--active');


        newData = this.items.sort(this.sortFn(typeSort, order));

        if (this.ProductionListingsInner) {
            this.ProductionListingsInner.deactivate();
            this.ProductionListingsInner.remove();
        }

        var $template = $(ProductionListingsInnerRuntime.render({
            data: newData
        }));

        $('.ProductionListings-body').html($template);

        this.ProductionListingsInner = new ProductionListingsInner({
            el: '.ProductionListingsInner'
        });

        this.ProductionListingsInner.activate();
    },


    toggleAll: function () {
        var isExpanded = this.ProductionListingsInner.toggleAll();

        this.$('.ProductionListings-header-item--expand .ProductionListings-header-itemText').text(isExpanded ? 'Close All' : 'Expand All');
    },


    sortFn: function (prop, order) {
        var orderVar = (order == 1) ? 2 : 0;

        return function (a, b) {
            if (a[prop].toLowerCase() > b[prop].toLowerCase()) {

                return (1 - orderVar);
            }
            if (a[prop].toLowerCase() < b[prop].toLowerCase()) {

                return (-1 + orderVar);
            }

            return 0;
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionListings/ProductionListings.js
// module id = 238
// module chunks = 0